import React, { useState, useEffect } from 'react';
import axios from 'axios';
import UserProduct from './userProduct';

const UserProductGrid = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    axios.get('/api/products')
      .then(response => {
        setProducts(response.data);
      })
      .catch(error => {
        console.error('Error fetching products:', error);
      });
  }, []);

  return (
    <div className="product-grid">
      {products.map(product => (
        <UserProduct key={product.product_id} product={product} />
      ))}
    </div>
  );
};

export default UserProductGrid;
